<template>
  <div style="height: 100%;background-color: #060C28;">
    <footer :class="{ detailPage: activeNav != 0 }">
      <div class="foot_container">
        <div class="foot_top">

          <div class="left">
            <ul>
              <li>
                <h4>产品中心</h4>
                <div class="item">
                  <a @click="toSubNav(1, 1)">工业质检行业专机</a>
                  <a @click="toSubNav(1, 5)">智能模组产品</a>
                  <a @click="toSubNav(1, 9)">AI智能平台</a>
                </div>
              </li>
              <li>
                <h4>核心技术</h4>
                <div class="item">
                  <a @click="toSubNav(2, 1)">AutoML</a>
                  <a @click="toSubNav(2, 2)">可信赖AI</a>
                  <a @click="toSubNav(2, 3)">主动学习</a>
                  <a @click="toSubNav(2, 4)">小样本学习</a>
                  <a @click="toSubNav(2, 5)">联邦学习</a>
                </div>
              </li>
              <li>
                <h4>行业应用</h4>
                <div class="item">
                  <a @click="toSubNav(3, 1)">半导体晶圆</a>
                  <a @click="toSubNav(3, 2)">电子元器件</a>
                  <a @click="toSubNav(3, 3)">新能源电池</a>
                  <a @click="toSubNav(3, 4)">太阳能光伏</a>
                  <a @click="toSubNav(3, 5)">3C电子</a>
                  <a @click="toSubNav(3, 6)">汽车制造</a>
                  <a @click="toSubNav(3, 7)">纺织工业</a>
                  <a @click="toSubNav(3, 8)">细菌检测</a>
                </div>
              </li>
              <li>
                <h4>关于识渊</h4>
                <div class="item">
                  <a @click="toSubNav(4, 1)">公司简介</a>
                  <a @click="toSubNav(4, 2)">新闻中心</a>
                  <a href="https://sailyond.jobs.feishu.cn/749776" target="_blank">加入我们</a>
                </div>
              </li>

            </ul>
          </div>

          <div class="logo">
            <img src="../assets/img/footer/logoFooter.png" alt="识渊科技">
            <div class="contact">
              <div class="phone">
                <h4>官方热线：</h4>
                <p>400-990-1219</p>
              </div>
              <div class="mail">
                <h4>商务合作：</h4>
                <span>sales@sailyond.com</span>
              </div>
            </div>
          </div>

        </div>

        <div class="foot_bottom">
          <div class="copyright">
            Copyright © 2022 深圳市识渊科技有限公司
            &nbsp;&nbsp;
            <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" class="record">备案号：粤ICP备2022147266号</a>
          </div>
        </div>

      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    activeNav: null,
    activeSubnav: null,
  },
  data() {
    return {
      // 移动端菜单显示隐藏
      wapNav: false,
      // 移动端选中导航
      activeMolideNav: null,
    }
  },
  mounted() {
  },
  methods: {
    toSubNav(nav, subNav) {
      let flag = document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight)
      let isTop = false
      if (flag) {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
        if (scrollTop == 0) {
          isTop = true
        }
      }

      // 首页
      if (nav == 0) {
        this.$router.push({
          path: '/'
        })
      }

      // 产品中心
      else if (nav == 1) {
        if (subNav == 0) {
          this.$router.push({
            name: 'ProdTab3'
          })
        }
        // 工业质检行业专机
        else if (subNav == 1 || subNav == 2 || subNav == 3 || subNav == 4) {
          this.$router.push({
            name: 'InspectionTab' + subNav
          })
          if (this.activeNav == 1 && this.activeSubnav == 1) {
            this.$parent.activeTab = subNav

            window.scrollTo({
              left: 0,
              top: (window.innerWidth * 1170 / 1200) + 60,
              behavior: 'auto'
            })
          }
        }
        // 智能模组产品
        else if (subNav == 5 || subNav == 6 || subNav == 7 || subNav == 8) {
          this.$router.push({
            name: 'IndustryTab' + (subNav - 4)
          })
          if (this.activeNav == 1 && this.activeSubnav == 2) {
            this.$parent.activeTab = subNav - 4

            if (isTop == false) {
              window.scrollTo({
                left: 0,
                top: (window.innerWidth * 1170 / 1200) + 60,
                behavior: 'auto'
              })
            }
          }

        }
        // 智能平台
        else if (subNav == 9) {
          this.$router.push({
            name: 'ProdTab2'
          })

          if (this.activeNav == 1 && this.activeSubnav == 3) {
            window.scrollTo({
              left: 0,
              top: 0,
              behavior: 'auto'
            })
          }
        }
      }

      // 核心技术
      else if (nav == 2) {
        if (subNav == 0) {
          this.$router.push({
            name: 'TechTab' + (subNav + 1)
          })

          if (this.activeNav == 2) {
            this.$parent.swiper.slideToLoop(subNav, 1000, false)
          }

        } else {
          this.$router.push({
            name: 'TechTab' + subNav
          })

          if (this.activeNav == 2) {
            this.$parent.swiper.slideToLoop(subNav - 1, 1000, false)
          }
        }

        if (this.activeNav == 2) {
          if (isTop == false) {
            const Top = document.getElementById('swiperTab')
            Top.scrollIntoView({ behavior: 'auto' })
          }
        }

      }

      // 行业应用
      else if (nav == 3) {
        if (subNav == 0) {
          this.$router.push({
            name: 'AppTab' + (subNav + 1)
          })

          if (this.activeNav == 3) {
            this.$parent.activeTab = subNav + 1
          }
        } else {
          this.$router.push({
            name: 'AppTab' + subNav
          })

          if (this.activeNav == 3) {
            this.$parent.activeTab = subNav
          }
        }

        if (this.activeNav == 3) {
          if (isTop == false) {
            window.scrollTo({
              left: 0,
              top: (window.innerWidth * 1170 / 1200) + 60,
              behavior: 'auto'
            })
          }
        }
      }

      // 关于识渊
      else if (nav == 4) {
        if (subNav == 0 || subNav == 1) {
          this.$router.push({
            name: 'AboutSailyond'
          })
        } else if (subNav == 2) {
          this.$router.push({
            name: 'News'
          })
        }

        if (this.activeNav == 4) {
          if (isTop == false) {
            window.scrollTo({
              left: 0,
              top: 0,
              behavior: 'auto'
            })
          }
        }
      }

      if (this.activeNav !== nav || subNav == 0 || (this.activeNav == nav && subNav == 9)) {
        window.scrollTo({
          left: 0,
          top: 0,
          behavior: 'auto'
        })
      }
      this.wapNav = false
    },
    // 移动端菜单收起和展开
    toggleNav(val) {
      if (val == this.activeMolideNav) {
        this.activeMolideNav = null
      } else {
        this.activeMolideNav = val
      }
    }
  }

}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Footer.vue